var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dashboard-filters',{attrs:{"options":_vm.options,"count":_vm.summary,"selectedFilter":_vm.selectedFilter,"setFilter":_vm.setMainFilter}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36dde2e5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/_dashboard/technical-status/filter/technical-status-filter.vue
// module id = o4G4
// module chunks = 1